import { render, staticRenderFns } from "./CostsDetails.vue?vue&type=template&id=aa62471e&scoped=true&"
import script from "./CostsDetails.vue?vue&type=script&lang=ts&"
export * from "./CostsDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa62471e",
  null
  
)

export default component.exports